"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const AutoSlider = () => {
  const services = [
    { 
      title: "Custom Web Development",
      icon: "💻",
      desc: "Tailored solutions for unique business needs"
    },
    { 
      title: "E-Commerce Solutions",
      icon: "🛒",
      desc: "Scalable online stores that convert"
    },
    { 
      title: "Mobile-First Design",
      icon: "📱",
      desc: "Responsive across all devices"
    },
    { 
      title: "SEO Optimization",
      icon: "🔍",
      desc: "Built for search engine success"
    },
    { 
      title: "24/7 Support",
      icon: "🛡️",
      desc: "Round-the-clock maintenance"
    },
    { 
      title: "UI/UX Focus",
      icon: "🎨",
      desc: "User-centered design philosophy"
    },
    { 
      title: "API Integration",
      icon: "🔌",
      desc: "Seamless system connections"
    },
    { 
      title: "Cloud Solutions",
      icon: "☁️",
      desc: "Secure & scalable hosting"
    },
    { 
      title: "Graphic Design",
      icon: "🖌️",
      desc: "Creative visuals that stand out"
    }
  ];

  // Define a list of popular services
  const popularServices = [
    "Custom Web Development",
    "E-Commerce Solutions",
    "SEO Optimization",
    "UI/UX Focus"
  ];
  
  return (
    <div className="w-full px-2 py-16 overflow-hidden dark:bg-gray-900">
      <Swiper
        slidesPerView={5}
        spaceBetween={25}
        loop={true}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        speed={2500}
        modules={[Autoplay]}
        className="mySwiper"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          1280: {
            slidesPerView: 5,
            spaceBetween: 25,
          }
        }}
      >
        {services.map((service, index) => (
          <SwiperSlide key={index}>
            <div className="relative p-6 rounded-2xl text-center bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transform transition-all duration-300 hover:border-primary">
              <div className="text-5xl mb-3">{service.icon}</div>
              <h3 className="text-xl font-bold mb-2 text-gray-800 dark:text-gray-200">
                {service.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                {service.desc}
              </p>

              {/* Display Popular Chip if the service is trending */}
              {popularServices.includes(service.title) && (
                <div className="absolute top-2 right-2">
                  <span className="px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-blue-500 to-purple-600 text-white">
                    Popular
                  </span>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AutoSlider;
